import React, { forwardRef, useState, useRef, useEffect } from "react";
import "./style.css";

const Textarea = forwardRef(
  ({ className = "", maxLength, showCounter = true, ...props }, ref) => {
    const [value, setValue] = useState("");
    const textareaRef = useRef(null);

    // Sync external ref with internal ref
    useEffect(() => {
      if (ref) {
        if (typeof ref === "function") {
          ref(textareaRef.current);
        } else {
          ref.current = textareaRef.current;
        }
      }
    }, [ref]);

    // Auto-resize logic
    const adjustHeight = () => {
      const el = textareaRef.current;
      if (el) {
        el.style.height = "auto"; // reset
        el.style.height = el.scrollHeight + "px"; // grow
      }
    };

    useEffect(() => {
      adjustHeight();
    }, [value]);

    const handleChange = (e) => {
      setValue(e.target.value);
      if (props.onChange) props.onChange(e);
    };

    return (
      <div className="textarea-wrapper">
        <textarea
          ref={textareaRef}
          className={`textarea ${className}`}
          maxLength={maxLength}
          value={value}
          onChange={handleChange}
          {...props}
        />
        {showCounter && maxLength && (
          <div
            className={`textarea-counter ${
              value.length >= maxLength * 0.9 ? "warning" : ""
            }`}
          >
            {value.length}/{maxLength}
          </div>
        )}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";

export { Textarea };


// Example Usage:

// export default function App() {
//   return (
//     <div style={{ maxWidth: "500px", margin: "2rem auto" }}>
//       <label
//         htmlFor="bio"
//         style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}
//       >
//         Tell us about yourself
//       </label>
//       <Textarea
//         id="bio"
//         placeholder="Start typing... the box will grow!"
//         rows={1} // minimal height
//         maxLength={300}
//         showCounter={true}
//       />
//     </div>
//   );
// }